const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

//cookie
var _cookieValue = 'v0';
var _cookieName = 'voted';
var date = new Date();
var _cookieExpires = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);

var _cookieValue2 = 'v1';
var _cookieName2 = 'cheered';

//preload
import {preload} from "../include/module";
preload();

// pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {
  scrollIndexAnime();

  // voteCookie();

  // $('.js-Vote').removeClass('close');
  // $('.js-Cheer').removeClass('close');

  setTimeout(function(){$('#st-Loader').addClass("load");},0);
  setTimeout(function(){$('#st-Loader').addClass("hidden");},100);
  setTimeout(function(){$('#st-Loader').remove();},2000);


});

// ------------------------------------------------------------------------
// voteCookie
// ----- BOTH
// ------------------------------------------------------------------------
const voteCookie = () => {

  // cookie
  var cookie = $.cookie(_cookieName);
  var cookie2 = $.cookie(_cookieName2);

  // タブのパラメータがついている時の対応
  var param = getParam('id');


  if(cookie !== _cookieValue || param == 'test-vote'){
    // 指定のcookieがブラウザにない場合
    $('.js-Vote').removeClass('close');
    console.log('none');
  }else{
    // 指定のcookieがブラウザにある場合
    $('.js-Vote').addClass('close');
    console.log('voted');
  }

  if(cookie2 !== _cookieValue2 || param == 'test-vote'){
    // 指定のcookieがブラウザにない場合
    $('.js-Cheer').removeClass('close');
    console.log('none');
  }else{
    // 指定のcookieがブラウザにある場合
    $('.js-Cheer').addClass('close');
    console.log('cheered');
  }

  //投票するボタン
  $('.js-Vote').on('click', function(){

    //cookie
    $.cookie(_cookieName, _cookieValue, { expires: _cookieExpires });
    $('.js-Vote').addClass('close');

  });

  //応援するボタン
  $('.js-Cheer').on('click', function(){

    //cookie
    $.cookie(_cookieName2, _cookieValue2, { expires: _cookieExpires });
    $('.js-Cheer').addClass('close');

  });

};

// ------------------------------------------------------------------------
// getParam
// ----- BOTH
// ------------------------------------------------------------------------

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  // //シーンを作成
  // const scene = new ScrollMagic.Scene({
  //     triggerElement: target,
  //     triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

  //アンカーリンク
  // const scene = new ScrollMagic.Scene({
  //   triggerElement:'#index-Vote',
  //   triggerHook: 1,
  //   offset: '-80'
  // })
  // .setClassToggle('#vote_Anchor', 'hidden')
  // .addTo(controller);

  //バンド背景
  // const scene2 = new ScrollMagic.Scene({
  //   triggerElement:'#index-Afterglow',
  //   triggerHook: 1,
  //   offset: '0'
  // })
  // .setClassToggle('#index-Bg', 'afterglow')
  // .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .8
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js